import { Input } from "./ui/input";

export const DAYS = [
    { key: "lun", label: "Lunedì" },
    { key: "mar", label: "Martedì" },
    { key: "mer", label: "Mercoledì" },
    { key: "gio", label: "Giovedì" },
    { key: "ven", label: "Venerdì" },
    { key: "sab", label: "Sabato" },
    { key: "dom", label: "Domenica" },
];

export const emptyWeek = () => Object.fromEntries(DAYS.map((d) => [d.key, { da: "", a: "" }]));

const toHours = (hhmm) => {
    const [h, m] = (hhmm || "").split(":").map(Number);
    return Number.isFinite(h) && Number.isFinite(m) ? h + m / 60 : null;
};

/** Ore totali di una settimana della griglia (turni a cavallo della mezzanotte inclusi). */
export const weekHours = (week) => DAYS.reduce((tot, d) => {
    const da = toHours(week?.[d.key]?.da), a = toHours(week?.[d.key]?.a);
    if (da == null || a == null) return tot;
    const diff = a - da;
    return tot + (diff < 0 ? diff + 24 : diff);
}, 0);

/** Griglia giorno → dalle/alle usata nella creazione del contratto e nelle comunicazioni di variazione orario. */
export const WeekGrid = ({ title, week, onChange, testPrefix }) => (
    <div className="min-w-0 rounded-md border border-slate-200 bg-white p-2">
        <p className="mb-1.5 text-xs font-semibold text-slate-600">{title}</p>
        <div className="space-y-1">
            {DAYS.map((d) => (
                <div key={d.key} className="grid grid-cols-[64px_minmax(0,1fr)_minmax(0,1fr)] items-center gap-1.5">
                    <span className="text-xs text-slate-500">{d.label}</span>
                    <Input
                        type="time"
                        value={week[d.key].da}
                        onChange={(e) => onChange(d.key, "da", e.target.value)}
                        className="h-8 w-full min-w-0 px-1.5 text-xs"
                        data-testid={`${testPrefix}-${d.key}-da`}
                    />
                    <Input
                        type="time"
                        value={week[d.key].a}
                        onChange={(e) => onChange(d.key, "a", e.target.value)}
                        className="h-8 w-full min-w-0 px-1.5 text-xs"
                        data-testid={`${testPrefix}-${d.key}-a`}
                    />
                </div>
            ))}
        </div>
    </div>
);
